import { useContentful, useBlogPosts, usePackages } from './useContentful';

// Hook to fetch brand home page specific content
export function useBrandHomePageImages() {
  // Since we don't have imageAsset or mediaAsset content types,
  // we'll return empty data to prevent errors
  const emptyData = { data: [], loading: false, error: null };

  return {
    loading: false,
    hero: {
      backgroundVideo: null,
      mastheadImage: null
    },
    carousel: {
      panel1: {
        fullImage: null,
        smallImage: null
      },
      panel2: {
        image1: null,
        image2: null,
        image3: null
      },
      panel3: null,
      panel4: null
    },
    destinations: {
      heroBackground: null,
      heroVideo: null,
      atacama: null,
      patagonia: null,
      iguazu: null,
      santaCatarina: null,
      mendoza: null
    },
    offers: [],
    blog: [],
    // Get all images for debugging
    allImages: {
      hero: [],
      carousel: [],
      destinations: [],
      offers: [],
      blog: []
    }
  };
}

// Hook to fetch brand home page text content
export function useBrandHomePageContent() {
  // Use the correct content type for page content
  const { data: pageContent, loading } = useContentful('pLrMSqiwtn4uSJcbEeq5j', {
    limit: 10
  });

  // Helper to find content by section
  const findContentBySection = (section: string) => {
    return pageContent.find((content: any) => 
      content.fields.sectionName === section
    )?.fields || {};
  };

  return {
    loading,
    hero: findContentBySection('brand-hero'),
    destinations: findContentBySection('brand-destinations'),
    offers: findContentBySection('brand-offers'),
    blog: findContentBySection('brand-blog'),
    conservation: findContentBySection('brand-conservation')
  };
}

// Hook for blog posts on brand home page
export function useBrandHomePageBlogPosts() {
  // Use the existing useBlogPosts hook
  const { data: blogPosts, loading } = useBlogPosts(5);

  return {
    loading,
    posts: blogPosts.map((post: any) => {
      const featuredImage = post.fields.featuredImage as any;
      const imageUrl = featuredImage?.fields?.file?.url;
      
      return {
        id: post.sys.id,
        title: post.fields.title,
        author: post.fields.author,
        date: post.fields.date,
        excerpt: post.fields.excerpt,
        link: `/blog/${post.fields.slug || post.sys.id}`,
        image: imageUrl ? `https:${imageUrl}` : null
      };
    })
  };
}

// Hook for offers on brand home page
export function useBrandHomePageOffers() {
  // Use packages instead of offers
  const { data: packages, loading } = usePackages();

  return {
    loading,
    offers: packages.slice(0, 3).map((pkg: any) => {
      const packageImage = pkg.fields.featuredImage as any;
      const imageUrl = packageImage?.fields?.file?.url;
      
      return {
        id: pkg.sys.id,
        title: pkg.fields.title,
        description: pkg.fields.description,
        image: imageUrl ? `https:${imageUrl}` : null,
        primaryButtonText: pkg.fields.buttonText || 'EXPLORE',
        secondaryButtonText: 'INQUIRE'
      };
    })
  };
}